import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { countryDateFormat, monthFormat } from '@shared/constants/formats';
import { formatDate, trimCreditCardNumber, withQueryParams } from '@shared/commonFunctions';
import { getError } from '@shared/utils/helpers';
import { ICardFormData, ICopyCard } from './types';

export const requestAddNewPayment = (contactId: string, dealId: string, data: ICardFormData) => {
  const path = `/${SERVICES.PAYMENT}/creditcards`;
  return mutate(path, async() => {
    try {
      const response = await axios.post(
        withQueryParams(path, {
          ContactId: contactId,
          CreditCardType: data.creditCardType,
          HolderName: data.holderName,
          CreditCardNumber: trimCreditCardNumber(data.cardNumber),
          ExpiryDate: formatDate(String(data.expiryDate), {
            format: monthFormat,
          }),
          Cvv: data.cvv,
          Amount: data.amount,
          ProcessingDate: formatDate(String(data.processingDate), {
            format: countryDateFormat,
          }),
          Notes: data.notes,
          DealId: dealId,
          DownPaymentOnDeal: data.amount,
          PaymentType: data.paymentType,
        }),
      );
      Notistack.successMessage('Payment - Added Successfully');

      return response;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateCard = (
  contactId: string,
  dealId: string,
  userId: string,
  formData: ICardFormData,
) => {
  const path = `/${SERVICES.PAYMENT}/creditcards`;
  return mutate(path, async() => {
    try {
      const response = await axios.put(
        withQueryParams(path, {
          DownPaymentId: formData.downPaymentId,
          ContactId: contactId,
          UserId: userId,
          DealId: dealId,
          CreditCardType: formData.creditCardType,
          HolderName: formData.holderName,
          CreditCardNumber: trimCreditCardNumber(formData.cardNumber),
          ExpiryDate: formatDate(String(formData.expiryDate), {
            format: monthFormat,
          }),
          Cvv: formData.cvv,
          Amount: formData.amount,
          ProcessingDate: formData.processingDate,
          Notes: formData.notes,
          DownPaymentOnDeal: formData.amount,
          PaymentType: formData.paymentType,
        }),
      );
      Notistack.successMessage('Credit Card - Updated Successfully');

      return response;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
export const requestProcessPayment = (
  contactId: string,
  dealId: string,
  userId: string,
  formData: ICardFormData,
) => {
  const path = `/${SERVICES.PAYMENT}/payments/process`;
  return mutate(path, async() => {
    try {
      const response = await axios.post(
        withQueryParams(path, {
          DownPaymentId: formData.downPaymentId,
          PaymentType: formData.paymentType,
          DealId: dealId,
          ContactId: contactId,
          UserId: userId,
          CreditCardType: formData.creditCardType,
          HolderName: formData.holderName,
          CreditCardNumber: formData.cardNumber,
          ExpiryDate: formatDate(String(formData.expiryDate), {
            format: monthFormat,
          }),
          Cvv: formData.cvv,
          Amount: formData.amount,
          ProcessingDate: String(formData.processingDate),
          Notes: formData.notes,
          DownPaymentOnDeal: formData.amount,
        }),
      );
      Notistack.successMessage('Payment Processed Successfully');

      return response;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestCancelPayment = (contactId: string, dealId: string, downPaymentId: string) => {
  const path = `/${SERVICES.PAYMENT}/payments/cancelpayment`;
  return mutate(path, async() => {
    try {
      const response = await axios.post(
        withQueryParams(path, {
          DownPaymentId: downPaymentId,
          DealId: dealId,
          ContactId: contactId,
        }),
      );
      Notistack.successMessage('Payment cancelled successfully');

      return response;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestAddCopyPayment = (data: ICopyCard) => {
  const path = `/${SERVICES.PAYMENT}/creditcards/copy`;
  return mutate(path, async () => {
    try {
      const response = await axios.post(path, data);
      Notistack.successMessage('Payment - Added Successfully');

      return response;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};